import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import Loader from "../../components/Loader/Loader";
import ModalPlayer from "../../components/PlayerModal/playerModal";
import SubTabsComponent from "./newUx/subTabs/SubTabs";
import { useSelector } from "react-redux";
import { Input } from "antd";
import { CloseActive, SearchZoomActive } from "../../components/Icons/Icons";
import { toast } from "react-toastify";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import { inputFieldCharLimit } from "../../config";
import './courses.scss'

const color = ["#E75E0D", "#EB9F11", "#ABC710", "#009340", "#CC0370", "#8366A9", "#149BD7"];

export default function Courses() {
  const navigate = useNavigate();
  const [activeKey,] = useState("courses");
  const localData = useSelector((state) => state?.localStorage)
  const { micrositeID, tabConfigId } = localData
  const id = micrositeID;
  const [loading, setLoading] = useState(true);
  const [responseData, setResponseData] = useState([]);
  const [videoUrl, setVideoUrl] = useState("");
  const [mediaType, setMediaType] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [textSearch, setTextSearch] = useState('')


  const getData = async (activeKey, id) => {
    setLoading(true)
    try {
      if (id) {
        const response = await getRequest(
          userapiservice.getMicrositeDetailsTabs(id, tabConfigId), 
          null, 
          false
        );
        setResponseData(response)
        setLoading(false);
      }
    } catch (error) { }
  };

  const convertToStandardURL = (shortUrl) => {
    if (shortUrl?.indexOf('youtu.be') !== -1) {
      const video_id = shortUrl?.split('youtu.be/')[1].split('?')[0];
      return `https://www.youtube.com/watch?v=${video_id}`;
    }
    return shortUrl;
  }

  const transformedData = responseData?.reduce((acc, item) => {
    const teamEntry = acc.find((entry) => entry.assetTitle === item?.assetTitle);
    const itemCopy = {
      id: item?.id,
      assetTitle: item?.assetTitle,
      subTitle: item?.subTitle,
      available: item?.available,
      description: item?.description,
      type: item?.type,
      mediaLink: {
        id: item?.mediaLink?.id,
        mediaType: item?.mediaLink?.mediaType,
        url: item?.mediaLink?.url,
        thumbnailUrl: item?.mediaLink?.thumbnailUrl,
      },
      order: item?.order,
      urlLink: item?.urlLink,
      micrositeLogo: item?.micrositeLogo,
    };

    if (teamEntry) {
      teamEntry.subTitles.push(itemCopy);
    } else {
      acc.push({
        assetTitle: item?.assetTitle,
        subTitles: [itemCopy],
      });
    }

    return acc;
  }, []);

  const PlayVideoHandler = (url, mediaType) => {
    setMediaType(mediaType);
    setVideoUrl(url);
    setIsModalOpen(true);
  };

  const onCardClickHandler = (data) => {
    navigate(`/microsite/${data.id}/micrositeDetails`, {
      state: { page: activeKey, data: data },
    });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setVideoUrl("");
  };




  const getServicesData = async (activeKey, id, searchKeyword) => {
    try {
      if (searchKeyword === "") {
        try {
          if (id) {
            const response = await getRequest(
              userapiservice.getMicrositeDetailsTabs(id, tabConfigId), {}, false
            );
            setResponseData(response)
            console.log('setResponseData', response);
            setLoading(false);
          }
        } catch (error) { }

      } else {
        setLoading(true);
        const paramData = {
          id: id,
          tabConfigId: tabConfigId,
        };


        const fetchResponse = await fetch(
          userapiservice.getTabsSearchData(paramData), // paramData goes in URL
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ text: searchKeyword }), // payload body
          }
        );

        const data = await fetchResponse.json();
        if (fetchResponse?.ok) {
          setResponseData(data);

        } else {
          const match = data?.message?.match(/\{"errors":\[.*\]\}/);
          if (match) {
            const parsed = JSON.parse(match[0]);
            if (parsed.errors && Array.isArray(parsed.errors) && parsed.errors.length > 0) {
              toast.error(parsed.errors[0].message);
            }
          } else if (data?.error) {
            toast.error(data.error);
          } else {
            toast.error("Invalid request. Please check your details and try again.");
          }
        }


      }


    } catch (error) {

      console.error("Error fetching news:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    // debouncing
    const handler = setTimeout(() => {
      getServicesData(activeKey, id, textSearch)
    }, 500)
    return () => {
      clearTimeout(handler)
    }
  }, [activeKey, id, textSearch]);


  return (
    <div
      className="background-container" >

      {loading ? <Loader /> : <>
        {activeKey === "courses" ? (
          <div>

            <div className="search-container" >
              <Input
                // className="title-bar-search"
                placeholder={"Search Courses"}
                maxLength={inputFieldCharLimit}
                prefix={
                  <SearchZoomActive style={{ color: "#CC0E2D", verticalAlign: "middle" }} />
                }
                suffix={textSearch.length > 0 && <span
                  onClick={() => {
                    setTextSearch('')
                    getData()
                  }}
                  className="btn btn-sm p-0 d-flex align-items-center">
                  <CloseActive customClassName={"search-clear-btn"} />
                </span>}
                // type="Date"
                value={textSearch}
                onChange={(e) =>
                  setTextSearch(e.target.value)
                }
                style={{ maxWidth: '300px' }}
              />
            </div>

            <SubTabsComponent
              data={transformedData}
              PlayVideoHandler={PlayVideoHandler}
              color={color}
              convertToStandardURL={convertToStandardURL}
              handleCancel={handleCancel}
              isModalOpen={isModalOpen}
              mediatype={mediaType}
              onCardClickHandler={onCardClickHandler}
              videoUrl={videoUrl}

            />

            {responseData.length === 0 && (
              <div className="background-container" style={{ width: "100%" }}>
                <div className="login-wall">
                  <div className="info-container">
                    <span>Nothing here at the moment</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (

          <></>
        )}
      </>}
      {isModalOpen && (
        <ModalPlayer
          closeModal={handleCancel}
          mediaLink={videoUrl}
          mediaType={mediaType}
        />
      )}
    </div>
  );
}
